import {
  Container,
  Stack,
  Grid,
  Box,
  FormControl,
  TextField,
  Divider,
  Button,
  CircularProgress,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import Alert from "@mui/material/Alert";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import "dayjs/locale/es"; // Importa el archivo de localización para español
import { ContextSession } from "../../../services/ContextSession";
import { useMediaQuery } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";

dayjs.locale("es"); // Establece el idioma local a español

function ConstanciaJubilacionScreen() {
  const isMobile = useMediaQuery("(max-width:820px)"); // Detectar si es una pantalla móvil
  const sessi = React.useContext(ContextSession);
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [fechaVacia, setFechaVacia] = React.useState(null);
  const [EstadoParticipante, setEstadoParticipante] = useState("");
  const [edad, setEdad] = useState(null); // Estado para la edad
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false); // Estado para manejar el loading del proceso de descarga

  useEffect(() => {
    const calcularEdad = () => {
      // Convertimos la fecha de nacimiento en un objeto Date
      const fechaNacimiento = new Date(selectedDate);
      const hoy = new Date(); // Obtenemos la fecha actual
      let edadCalculada = hoy.getFullYear() - fechaNacimiento.getFullYear(); // Calculamos la diferencia de años
      const mes = hoy.getMonth() - fechaNacimiento.getMonth(); // Comparamos los meses
      if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNacimiento.getDate())) {
        edadCalculada--; // Si aún no hemos cumplido años este año, restamos 1
      }
      setEdad(edadCalculada); // Establecemos el valor de la edad en el estado
    };

    calcularEdad(); // Llamamos a la función para calcular la edad al montar el componente
  }, [selectedDate]); // Se ejecuta cada vez que cambia selectedDate

  function CustomDatePickerNacimiento(props) {
    const today = dayjs();
    const [invalidFormat, setInvalidFormat] = React.useState(false);
    const [cleared, setCleared] = React.useState(false);

    React.useEffect(() => {
      if (cleared) {
        setSelectedDate(null);
        const timeout = setTimeout(() => {
          setCleared(false);
        }, 1500);

        return () => clearTimeout(timeout);
      }
      return () => {};
    }, [cleared]);

    const handleDateChange = (date) => {
      if (date && !dayjs(date, "DD/MM/YYYY").isValid()) {
        setInvalidFormat(true);
      } else {
        setInvalidFormat(false);
        setSelectedDate(date);
        setFechaVacia(false);
      }
    };

    const handleKeyDown = (event) => {
      event.preventDefault(); // Evitar la entrada manual
    };

    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoItem>
          <DatePicker
            readOnly
            format={"DD/MM/YYYY"}
            value={selectedDate}
            views={["year", "month", "day"]}
            onAccept={handleDateChange}
            slotProps={{
              field: {
                clearable: true,
                onClear: () => setCleared(true),
                InputProps: {
                  readOnly: true, // Hacer el campo solo lectura
                },
              },
              textField: {
                variant: "filled", // Cambiar la variante a 'filled'
                helperText: fechaVacia
                  ? "Seleccione la fecha de nacimiento"
                  : invalidFormat
                  ? "Formato de fecha incorrecto"
                  : selectedDate && dayjs(selectedDate).isAfter(today)
                  ? "La fecha seleccionada es mayor a la fecha actual"
                  : null,
                error: fechaVacia || invalidFormat,
                onKeyDown: handleKeyDown,
              },
            }}
            maxDate={today}
            {...props}
          />
        </DemoItem>
        {cleared && (
          <Alert
            sx={{ position: "absolute", bottom: 0, right: 0 }}
            severity="success"
          >
            Fecha Borrada!
          </Alert>
        )}
      </LocalizationProvider>
    );
  }

  useEffect(() => {
    const sessionData = JSON.parse(localStorage.getItem("sessionData"));

    if (sessionData) {
      sessi.sessionData = sessionData; // Restaurar datos de sesión
    }

    setEstadoParticipante(sessi.sessionData.estado); // Setear el estado del participante
    const useFront =
      "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
    async function fetchData() {
      const queryString = `dni=${sessi.sessionData.identidad}`;
      const signature = CryptoJS.HmacSHA256(queryString, useFront).toString(
        CryptoJS.enc.Hex
      );
      setLoading(true);
      try {
        const dni = sessi.sessionData.identidad;
        const formData = new FormData();
        formData.append("dni", dni);

        const response = await fetch(
          `https://be.injupemp.gob.hn:8443/api/datos/`,
          {
            method: "POST",
            body: formData,
            headers: {
              "X-Signature": signature,
            },
          }
        );

        const data = await response.json();
        if (data && data.informacion) {
          const info = data.informacion.reduce((acc, item) => {
            const [key, value] = item.split(": ");
            acc[key.trim()] = value ? value.trim() : "";
            return acc;
          }, {});

          setFormData({
            nombres: `${info.Nombre1 || ""} ${info.Nombre2 || ""}`,
            apellidos: `${info.Apellido1 || ""} ${info.Apellido2 || ""}`,
            fechaNacimiento: dayjs(
              info.FechaNacimiento,
              "DD/MM/YYYY HH:mm:ss a"
            ),
          });
          setSelectedDate(dayjs(info.FechaNacimiento, "DD/MM/YYYY HH:mm:ss a"));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []); // Asegúrate de que se ejecute en la primera carga y recarga

  // Guarda sessi.sessionData en el localStorage para persistencia
  useEffect(() => {
    if (sessi.sessionData) {
      localStorage.setItem("sessionData", JSON.stringify(sessi.sessionData));
    }
  }, [sessi.sessionData]);

  const [formData, setFormData] = useState({
    nombres: "",
    apellidos: "",
    fechaNacimiento: null,
  });

  const handleDownload = async () => {
    setLoading(true); // Activar el estado de carga

    try {
      const useFront =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8"; // Mismo secret
      const dni = sessi.sessionData.identidad;

      const queryString = `identidad=${dni}`;
      const signature = CryptoJS.HmacSHA256(queryString, useFront).toString(
        CryptoJS.enc.Hex
      );

      // Crear el FormData para la API SolconstanciaGra
      const formData = new FormData();
      formData.append("identidad", dni);
      formData.append("UsuarioID", sessi.sessionData.id);
      formData.append("Nombre", sessi.sessionData.nombre);
      formData.append("DetalleSolicitud", "CONSTANCIA");

      // Realizar la solicitud a SolconstanciaGra
      const response = await fetch(
        "https://be.injupemp.gob.hn:8443/api/SolconstanciaGra/",
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${sessi.sessionData.token}`, // Token normal
            "X-Signature": signature, // Firma personalizada
          },
        }
      );

      if (!response.ok) {
        // Si el token expiró (401 Unauthorized), redirigir al login
        if (response.status === 401) {
          const result = await response.json();
          if (result.code === "token_not_valid") {
            // Limpiar sesión y redirigir
            sessi.clearSession();
            navigate("/Login");
            return [];
          }
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      if (!response.ok) {
        throw new Error("Error al enviar la solicitud a la API");
      }

      // Procesar la respuesta
      const data = await response.json();
      if (!data.constancia_base64) {
        throw new Error("No se recibió la constancia en la respuesta");
      }

      // Convertir Base64 a Blob y descargar el PDF
      const pdfBlob = new Blob(
        [Uint8Array.from(atob(data.constancia_base64), (c) => c.charCodeAt(0))],
        {
          type: "application/pdf",
        }
      );

      const link = document.createElement("a");
      link.href = URL.createObjectURL(pdfBlob);
      link.download = `constancia_${data.identidad}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error:", error);
      alert(
        "Hubo un error al procesar la solicitud. Por favor, intente de nuevo."
      );
    } finally {
      setLoading(false); // Desactivar el estado de carga
    }
  };

  return (
    <div id="my-container">
      <Container style={{ marginTop: isMobile ? 1 : 50 }}>
        <Grid container justify="center" alignItems="center">
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <h1>SOLICITUD DE CONSTANCIA PARA PENSIONADO</h1>
          </Grid>
        </Grid>
        <Divider style={{ marginTop: 20 }} />

        <Box marginTop={2}>
          <Stack direction="row">
            <h3>I. DATOS DEL SOLICITANTE</h3>
          </Stack>
          <Stack direction={isMobile ? "column" : "row"} mt={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <TextField
                    id="NumeroIdentidad"
                    label="Número de Identidad"
                    variant="filled"
                    value={sessi.sessionData.identidad}
                    inputProps={{ maxLength: 13 }} // Limitar la longitud máxima a 13 caracteres
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <TextField
                    id="Nombres"
                    label="Nombres"
                    variant="filled"
                    value={formData.nombres}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <TextField
                    id="Apellidos"
                    label="Apellidos"
                    variant="filled"
                    value={formData.apellidos}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <CustomDatePickerNacimiento
                    id="FechaNacimiento"
                    label="Fecha Nacimiento"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <TextField
                    id="Edad"
                    label="Edad"
                    value={`${edad} años`}
                    variant="filled"
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Stack>
        </Box>
        <Divider style={{ marginTop: 5 }} />

        {/* Botón para descargar la constancia */}
        <Grid container justifyContent="center" style={{ marginTop: 20 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleDownload}
            startIcon={<DownloadIcon />}
            disabled={loading} // Deshabilitar el botón si está cargando
            style={{ position: "relative" }}
          >
            Descargar Constancia
            {loading && (
              <CircularProgress
                size={24}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: -12,
                  marginLeft: -12,
                }}
              />
            )}
          </Button>
        </Grid>
      </Container>
    </div>
  );
}

export default ConstanciaJubilacionScreen;
